import { inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { User } from '@core/models';
import { Store } from '@ngrx/store';
import { AppState } from '../store/reducers';
import { selectCurrentUser } from '../store/reducers/users.reducer';

export function userStateBaseGuard(): User | undefined {
  const store = inject(Store<AppState>);
  store.select(selectCurrentUser).pipe(takeUntilDestroyed()).subscribe(u => {
    return u;
  });

  return undefined;
}

